import "./StrategyColumnSelect.scss";
import {IModalInstanceService} from "angular-ui-bootstrap";
import {ObjectUtil} from "../../../js/util/ObjectUtil";
import {
    StrategyColumnConfig,
    StrategyColumnPreset,
    strategyColumnPresets,
    StrategyColumnPresets
} from "./StrategyColumns";
import {IOnDestroy, IScope} from "angular";
import {BehaviorSubject} from "rxjs/BehaviorSubject";
import {Subscription} from "rxjs/Subscription";
import {StringKeyed} from "../../../types/GenericTypes";

export class StrategyColumnSelectController implements IOnDestroy {

    public selectedColumns: StrategyColumnConfig;
    public presets: StrategyColumnPresets;

    private changesSub = Subscription.EMPTY;

    /** @ngInject */
    public constructor(private $scope: IScope,
                       private $uibModalInstance: IModalInstanceService,
                       private changes: BehaviorSubject<StrategyColumnConfig>,
                       private terms: StringKeyed<any>) {
        this.changesSub = this.changes.subscribe(columns => this.selectedColumns = columns);
        this.presets = strategyColumnPresets(this.terms);
        this.watchForDismiss();
    }

    private watchForDismiss() {
        this.$scope.$on("modal.closing", (event, reason, closed) => {
            if (!closed) {
                event.preventDefault();
                this.close();
            }
        });
    }

    public toggleSelection($event: JQueryEventObject, column: keyof StrategyColumnConfig) {
        if (!$event.isDefaultPrevented()) {
            const current = ObjectUtil.copy(this.selectedColumns);
            current[column].visible = !current[column].visible;
            this.changes.next(current);
        }
    }

    public select(preset: StrategyColumnPreset) {
        const selected = ObjectUtil.copy(preset.columns);
        this.changes.next(selected);
        this.close();
    }

    public close() {
        this.$uibModalInstance.close();
    }

    public $onDestroy(): void {
        this.changesSub.unsubscribe();
    }
}
